import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Signal,
} from '@angular/core';

import { select, Store } from '@ngxs/store';
import { DismissNotificationBanner, ShellState } from '../shell.state';
import { NotificationBannerBuildingBlockComponent } from 'building-blocks/notification-banner/notification-banner.component';
import { NotificationBanner } from 'www-cms';

@Component({
  selector: 'ss-www-notification-banner',
  imports: [NotificationBannerBuildingBlockComponent],
  templateUrl: './notification-banner.component.html',
  styleUrl: './notification-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Angular seems to have changed directions, they used to recommend using host binding
  // for classes, but now they recommend using the host syntax. https://github.com/angular/angular/issues/52561
  // RIP decorators.  Also, there is no type safety for this.  Hopefully angular language service will catch up.
  // Added unit test to avoid regressions.
  host: {
    '[class.hidden]': '!notificationBannerForRoute() || !containsWebsite()',
  },
})
export class NotificationBannerComponent {
  private store = inject(Store);

  notificationBannerForRoute: Signal<NotificationBanner | undefined> = select(
    ShellState.getNotificationBannerForRoute
  );

  containsWebsite = computed(() => {
    const banner = this.notificationBannerForRoute();
    if (!banner) {
      return false;
    }
    return (
      this.notificationBannerForRoute()?.displayOn?.includes('www') ?? false
    );
  });

  closeNotificationBanner() {
    if (!this.notificationBannerForRoute()) {
      return;
    }
    this.store.dispatch(
      new DismissNotificationBanner(this.notificationBannerForRoute()!.id)
    );
  }
}
